import React from 'react';
import ViewMessage from '@components/ViewMessage';
import { NavNotesIcon } from '@components/Icons';
import { Key } from '@components/KeyboardShortcut';

export default function EmptyNotes() {
  return (
    <ViewMessage
      underHeader
      icon={<NavNotesIcon color="textPrimary" width="18" height="22" />}
      headline="No Notes yet"
      message={
        <>
          Add a new Note for
          <br />
          someone from anywhere by
          <br />
          typing <Key>N</Key>
        </>
      }
    />
  );
}
